import { Injectable } from '@angular/core';
import { createClient, Session, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupabaseService {
  private supabase: SupabaseClient;

  constructor() {
    this.supabase = createClient(environment.supabaseUrl, environment.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        // Stable, project-scoped key. Without this, supabase-js derives the key
        // from supabaseUrl — which changes when the URL host changes (LAN IP
        // vs localhost in dev, or any past project rotation), silently
        // stranding installed clients on the old key and presenting as a logout.
        storageKey: 'buildersturf-auth',
      },
    });
  }

  getSession() {
    return this.supabase.auth.getSession();
  }

  get client(): SupabaseClient {
    return this.supabase;
  }

  // Auth helpers
  async signIn(email: string, password: string) {
    return await this.supabase.auth.signInWithPassword({ email, password });
  }

  async signUp(email: string, password: string) {
    return await this.supabase.auth.signUp({ email, password });
  }

  async signOut() {
    return await this.supabase.auth.signOut();
  }

  getCurrentUser() {
    return this.supabase.auth.getUser();
  }

  onAuthStateChange(callback: (event: string, session: Session | null) => void) {
    return this.supabase.auth.onAuthStateChange(callback);
  }

  // Password reset
  async resetPasswordForEmail(email: string, redirectTo?: string) {
    return await this.supabase.auth.resetPasswordForEmail(email, {
      redirectTo: redirectTo || `${window.location.origin}/auth/reset-password`,
    });
  }
}
